import React from 'react';
import { File } from '../index';
import FilePreviewModal from '../components/PreviewModal/FilePreviewModal';
import { supportsPreview } from '../utils';

type PreviewFile = Pick<File, 'id' | 'type' | 'originalUrl' | 'previewUrl'>;

interface PreviewContextType {
  file: Nullable<PreviewFile>;
  setFile: React.Dispatch<React.SetStateAction<Nullable<PreviewFile>>>;
}

const PreviewContext = React.createContext<PreviewContextType>({
  file: null,
  setFile: () => {},
});

export const useFilePreview = () => {
  const { setFile } = React.useContext(PreviewContext);

  const launchPreview = (file: PreviewFile) => {
    if (supportsPreview(file.type)) {
      setFile(file);
    }
  };

  return {
    launchPreview,
  };
};

const FilePreviewProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [file, setFile] = React.useState<Nullable<PreviewFile>>(null);

  const handleClose = React.useCallback(() => {
    setFile(null);
  }, [setFile]);

  return (
    <PreviewContext.Provider value={{ file, setFile }}>
      {children}
      {file && <FilePreviewModal file={file} onClose={handleClose} />}
    </PreviewContext.Provider>
  );
};

export default FilePreviewProvider;
